import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { MyIcon, IMG_DEFAULT } from '../../common/baseConfig';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import * as actions from './redux/actions';

export class ExperienceClass extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {}
  render() {
    const {
      model: { Coursedetaillist },
    } = this.props;
    console.log(Coursedetaillist);
    return null;
    // return (
    //   <div className="home-experience-class">
    //     {fetchGetExperienceClassSuccess.length > 0 && (
    //       <div className="home-experience-class-inner">
    //         <div className="home-experience-class-list">
    //           {fetchGetExperienceClassSuccess.map((item, key) => (
    //             <div className="list-item" key={key}>
    //               <img
    //                 src={
    //                   item.CoverPath
    //                     ? item.CoverPath + '?x-oss-process=image/resize,m_fixed,h_158,w_283'
    //                     : IMG_DEFAULT
    //                 }
    //                 alt=""
    //               />
    //               <div className="content">
    //                 <p className="title">{item.Name}</p>
    //               </div>
    //               <div className="bottom-view">
    //                 <p>
    //                   <MyIcon className="num-icon" type="iconrenshu" />
    //                   <span>{item.BuyBase + item.BuyCount}</span>
    //                 </p>
    //                 <p>
    //                   <Link to={`/course/detail/${item.ID}`} target="_blank">
    //                     <Button className="try-btn" type="theme2">
    //                       <span>免费试听</span>
    //                       <MyIcon type="iconmianfeishiting" className="try-icon" />
    //                     </Button>
    //                   </Link>
    //                 </p>
    //               </div>
    //             </div>
    //           ))}
    //         </div>
    //       </div>
    //     )}
    //   </div>
    // );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExperienceClass);



// WEBPACK FOOTER //
// ./src/features/home/ExperienceClass.js